import styled from 'styled-components';

import {colors} from 'theme';

export const BatchSection = styled.div`
    margin-top: 24px;
`;

export const BatchSectionTitle = styled.h3`
    margin: 0 0 12px;
    font-size: 14px;
`;

export const BatchTableWrapper = styled.div`
    overflow-x: auto;
    border: 1px solid ${colors.border};
`;

export const BatchTable = styled.table`
    width: 100%;
    min-width: 640px;
    border-collapse: collapse;
    table-layout: fixed;

    th,
    td {
        padding: 12px;
        border-bottom: 1px solid ${colors.border};
        text-align: left;
        font-size: 12px;
    }

    th {
        color: ${colors.textMuted};
        font-weight: 500;
    }

    tbody tr {
        cursor: pointer;

        &:hover {
            background-color: ${colors.background};
        }

        &:last-child td {
            border-bottom: 0;
        }
    }
`;

export const RadioCell = styled.td`
    width: 44px;
`;

export const BatchSelectionList = styled.div`
    display: flex;
    flex: none;
    flex-direction: column;
    gap: 8px;
    max-height: 500px;
    overflow-y: auto;
`;

export const BatchSelectionModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
`;

export const BatchSelectionActions = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
`;

export const BatchSelectionItem = styled.label<{$selected: boolean}>`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    border-radius: 6px;
    background: ${({$selected}) => ($selected ? colors.brandLight : 'transparent')};
    cursor: pointer;

    &:hover {
        background: ${colors.background};
    }
`;

export const BatchSelectionRadio = styled.input`
    width: 16px;
    height: 16px;
    margin: 2px 0 0;
    accent-color: ${colors.brandPrimary};
    cursor: pointer;
`;

export const BatchSelectionDetails = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
`;

export const BatchSelectionNumber = styled.div`
    color: ${colors.textPrimary};
    font-size: 14px;
    font-weight: 600;
`;

export const BatchSelectionMeta = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px 20px;
    color: ${colors.textMuted};
    font-size: 12px;
    line-height: 18px;
`;
